// Direct checkout destinations for each offer tier.
export const BASE_CHECKOUT_URL = 'https://www.manualeslistos.com/cart/62963550552394:1';
export const KIT_CHECKOUT_URL = 'https://www.manualeslistos.com/cart/62963554189642:1';
